import { render, staticRenderFns } from "./VideoRed.vue?vue&type=template&id=1178a18e&"
import script from "./VideoRed.vue?vue&type=script&lang=js&"
export * from "./VideoRed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports